<template>

       <div class="flex flex-wrap gap-4 text-xs font-mono text-gray-700 mt-4 mb-4 ml-2">

  <div
    v-for="(item,i) in colores"
    :key="i" class="flex items-center gap-2"
  >
    <span
      class="w-4 h-4 rounded border border-gray-300"
      :style="{ backgroundColor: item }"
    ></span>

    <span>{{ leyenda[i] }}</span>
  </div>

</div> 


</template>

<script>

export default {
 

  props: {
    colores: {
      type: Array,
      required: true,
    },
     leyenda: {
      type: Array,
      required: true,
    }
  }  
}  
</script>